function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.254 11.986v3.269H2.179v-3.269H0v3.269a2.186 2.186 0 002.179 2.179h13.075a2.186 2.186 0 002.179-2.179v-3.269zm-1.09-4.358l-1.536-1.536L9.806 8.9V0H7.627v8.9L4.805 6.091 3.269 7.627l5.448 5.448z"
});
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.434,
    height: 17.434,
    viewBox: "0 0 17.434 17.434"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='17.434' height='17.434' viewBox='0 0 17.434 17.434'%3e %3cpath fill='%23fff' d='M19.254 15.986v3.269H6.179v-3.269H4v3.269a2.186 2.186 0 0 0 2.179 2.179h13.075a2.186 2.186 0 0 0 2.179-2.179v-3.269zm-1.09-4.358l-1.536-1.536-2.822 2.808V4h-2.179v8.9l-2.822-2.809-1.536 1.536 5.448 5.448z' transform='translate(-4 -4)'/%3e %3c/svg%3e";
export { SvgDownload as ReactComponent };